import { render, staticRenderFns } from "./MotegiParts.vue?vue&type=template&id=65f04aa7&scoped=true"
import script from "./MotegiParts.vue?vue&type=script&lang=ts"
export * from "./MotegiParts.vue?vue&type=script&lang=ts"
import style0 from "./MotegiParts.vue?vue&type=style&index=0&id=65f04aa7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f04aa7",
  null
  
)

export default component.exports